import React from "react";

import { Gradient } from "whatamesh";

import { useEffect } from "react";
import "../styles/banner.css"

import 'reactflow/dist/style.css';


export default function Banner() {
    const gradient = new Gradient()

    var edges = [];

    useEffect(() => {
        gradient.initGradient('#gradient-canvas')
    }, []);

    return (
        <div id="Banner">
            <div id="BannerInner">
                <div>
                <h1>EduCare</h1>
                <p>Forming your future</p>
                </div>
            </div>
            <canvas id="gradient-canvas" data-transition-in></canvas>
      </div>
    );
    }
